import * as React from 'react'
import VehicleActivitiesActionBar from '../shared/actionBars/VehicleActivitiesActionBar'
import Weekly from '../tabs/activities/views/Weekly'

export const VehicleWeeklyActivityPage = () => (
  <div>
    <div className="tw-relative tw-bg-content-primary">
      <VehicleActivitiesActionBar printView="weekly" />
    </div>
    <Weekly />
  </div>
)
